<template>
  <h2 :class="$style.title">Non-Permitted Activity</h2>
  <p>
    Funds provided by Clearco cannot be used directly or indirectly, in any
    manner in:
  </p>
  <div :class="$style.legal_blurb">
    <ol>
      <li>
        <p>The following prohibited industries:</p>
        <ul>
          <li>
            fire arms or other weaponry, including parts, accessories, and
            ammunition
          </li>
          <li>
            adult entertainment, adult services, adult paraphernalia retail and
            pornography
          </li>
          <li>pawn shops</li>
          <li>gambling and lottery industries</li>
          <li>car and other auto dealers</li>
          <li>real estate</li>
          <li>not for profit and co-op organizations</li>
          <li>marijuana (including legalized and medicinal)</li>
          <li>
            any business deriving 10% or more of its revenue from the production
            of spirits and/or liquors
          </li>
          <li>organizations involved in influencing politics or government</li>
          <li>bail bondsmen</li>
          <li>fireworks</li>
          <li>
            fossil fuel extraction, refining, transportation and distribution
          </li>
          <li>
            any other industry sector or practice deemed to be unlawful by U.S.
            state or federal law;
          </li>
        </ul>
      </li>
      <li>
        Any non-permitted activity set forth in
        <a
          href="https://support.currencycloud.com/hc/en-gb/articles/360017472339-Non-permitted-activity"
          >https://support.currencycloud.com/hc/en-gb/articles/360017472339-Non-permitted-activity</a
        >
        as may be updated from time to time; and
      </li>
      <li>
        Any other non-permitted activity as communicated by Clearco in writing
      </li>
    </ol>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';

export default {
  setup() {
    useMeta({ title: 'Non-permitted Activity' });
  },
};
</script>

<style lang="less" module>
.title {
  font-family: @regular-font;
  margin: 50px auto;
  padding: 0 20px;
  text-align: center;
}
.legal_blurb ol {
  list-style-type: decimal;
  list-style-position: inside;
  list-style: decimal;
  margin: initial;
  padding: 0 25px;

  li {
    padding: 0 0 25px;
    white-space: trim;

    ul {
      list-style-type: circle;
      list-style-position: inside;
      margin-left: 15px;

      li {
        padding: 0;
      }
    }
  }
}
</style>
